import type { TEmitterType } from '@semios/app-platform-values-helpers-and-types'

export const getEmittersToSelect = (selectedEmitters: TEmitterType[], availableEmitters: TEmitterType[]) => {
  if (availableEmitters.length === 0) return selectedEmitters

  const isOneAvailableEmitterSelected =
    selectedEmitters.length === 1 && selectedEmitters.every((emitter) => availableEmitters.includes(emitter))

  const areAllAvailableEmittersSelected =
    selectedEmitters.length === availableEmitters.length &&
    availableEmitters.every((emitter) => selectedEmitters.includes(emitter))

  return isOneAvailableEmitterSelected || areAllAvailableEmittersSelected
    ? selectedEmitters
    : availableEmitters
}
